import { ManageFundsRequestsPage } from 'features/funds-request';

export const TechOperatorFundsRequestsPage: React.FC = () => (
  <ManageFundsRequestsPage />
);
